{
  "minimum": "Minimum",
  "maximum": "Maximum"
}
